<template>
  <b-card no-body class="overflow-hidden">
    <b-card-header
      @click="collapse = !collapse"
      class="p-3 bg-white h4 cursor-pointer d-flex"
      :class="collapse ? 'pb-0' : 'pb-3'"
    >
      <div>Potential Donor List</div>
      <div class="flex-grow-1"></div>
      <b-icon :icon="!collapse ? 'chevron-down' : 'chevron-up'"></b-icon>
    </b-card-header>
    <b-collapse v-model="collapse">
      <table-view
        :fields="fields"
        :isBusy="isLoading"
        :items="list"
        ref="table"
      >
        <template v-slot:status="{ item }">
          {{ getStatus(item) }}
        </template>
        <template v-slot:action="{ item }">
          <div class="d-flex">
            <Menu
              :item="item"
              @onDraftStateCompleted="$emit('onDraftStateCompleted')"
              v-if="isMenu(item)"
              @fetch="$emit('fetch')"
              @changeStatus="changeStatus"
            ></Menu>
            <view-button v-if="isView(item)"> </view-button>
            <edit-button v-else @click="open(item)"></edit-button>
            <b-button
              v-if="isAdmins && item.medical_legal_case == '1'"
              variant="warning"
              size="sm"
              class="mx-1"
              title="Send MLC Notification"
              @click="openMLCModal(item)"
            >
              MLC
            </b-button>
            <delete-button
              v-if="isDeleteAble(item)"
              @click="remove(item)"
            ></delete-button>
            <termination
              :id="item.donor_temp_registration_id"
              @fetch="$emit('fetch')"
              v-if="isTerminated(item)"
            ></termination>
          </div>
        </template>
      </table-view>
    </b-collapse>

    <!-- MLC Send Notification Modal -->
    <b-modal
      v-model="mlcDialog"
      title="Send MLC Notifications"
      size="lg"
      centered
      hide-footer
    >
      <form-wrapper @submit="sendMLCNotification">
        <div class="mb-3">
          <strong>Donor:</strong> {{ mlcForm.donor_name }} |
          <strong>AR No:</strong> {{ mlcForm.mlc_ar_no }} |
          <strong>Hospital:</strong> {{ mlcForm.hospital_name }}
        </div>

        <!-- Police -->
        <div class="h6 mt-3">Police</div>
        <b-row class="pb-0">
          <b-col cols="12" md="6">
            <input-field
              v-model="mlcForm.mlc_police_mail"
              label="Police Mail ID"
              rules="email|max-150"
            />
          </b-col>
          <b-col cols="12" md="6">
            <input-field
              v-model="mlcForm.mlc_police_phone"
              label="Police Phone"
              rules="max-20"
            />
          </b-col>
        </b-row>

        <!-- Nodal Officer -->
        <div class="h6 mt-3">Nodal Officer</div>
        <b-row class="pb-0">
          <b-col cols="12" md="6">
            <input-field
              v-model="mlcForm.mlc_nodal_officer_mail"
              label="Nodal Officer Mail ID"
              rules="email|max-150"
            />
          </b-col>
          <b-col cols="12" md="6">
            <input-field
              v-model="mlcForm.mlc_nodal_officer_phone"
              label="Nodal Officer Phone"
              rules="max-20"
            />
          </b-col>
        </b-row>

        <!-- HOD Forensic Department -->
        <div class="h6 mt-3">HOD Forensic Department</div>
        <b-row class="pb-0">
          <b-col cols="12" md="6">
            <input-field
              v-model="mlcForm.mlc_hod_forensic_mail"
              label="HOD Forensic Dept Mail ID"
              rules="email|max-150"
            />
          </b-col>
          <b-col cols="12" md="6">
            <input-field
              v-model="mlcForm.mlc_hod_forensic_phone"
              label="HOD Forensic Dept Phone"
              rules="max-20"
            />
          </b-col>
        </b-row>

        <!-- Channels -->
        <b-row class="pb-0 mt-3">
          <b-col cols="12" md="4">
            <yes-no v-model="mlcForm.sendEmail" label="Send Email" />
          </b-col>
          <b-col cols="12" md="4">
            <yes-no v-model="mlcForm.sendSMS" label="Send SMS" />
          </b-col>
          <b-col cols="12" md="4">
            <yes-no v-model="mlcForm.sendWhatsApp" label="Send WhatsApp" />
          </b-col>
        </b-row>

        <!-- Email Preview -->
        <div v-if="mlcForm.sendEmail == 1 && emailTemplate" class="mt-2">
          <div class="h6">Email Preview</div>
          <div class="border rounded p-2 bg-light mb-2">
            <small class="text-muted">Subject:</small> {{ filledEmailSubject }}
          </div>
          <div
            class="border rounded p-2 bg-light mb-3"
            style="font-size: 13px"
            v-html="filledEmailBody"
          ></div>
        </div>

        <!-- SMS Preview -->
        <div v-if="mlcForm.sendSMS == 1 && smsTemplate" class="mt-2">
          <div class="h6">SMS Preview</div>
          <div
            class="border rounded p-2 bg-light mb-3"
            style="font-size: 13px"
          >
            {{ filledSmsBody }}
          </div>
        </div>

        <!-- WhatsApp Preview -->
        <div v-if="mlcForm.sendWhatsApp == 1 && whatsappTemplate" class="mt-2">
          <div class="h6">WhatsApp Preview</div>
          <div
            class="border rounded p-2 bg-light mb-3"
            style="font-size: 13px; white-space: pre-line"
          >
            {{ filledWhatsappBody }}
          </div>
        </div>

        <!-- Notification Log -->
        <MLCNotificationLog
          v-if="mlcForm.donor_registration_id"
          :donor-registration-id="mlcForm.donor_registration_id"
          ref="mlcLog"
          class="mt-3"
        />

        <!-- Footer -->
        <div class="d-flex mt-3">
          <div class="flex-grow-1"></div>
          <b-button variant="outline-danger" class="mx-3" @click="mlcDialog = false">
            Cancel
          </b-button>
          <b-button
            variant="success"
            type="submit"
            :disabled="mlcSending || (!mlcForm.sendEmail && !mlcForm.sendSMS && !mlcForm.sendWhatsApp)"
          >
            {{ mlcSending ? "Sending..." : "Send Notifications" }}
          </b-button>
        </div>
      </form-wrapper>
    </b-modal>
  </b-card>
</template>

<script>
import { encode } from "../../assets/js/common";
import { DONOR_STATUS } from "../../assets/constants/donor.constants";
import DeleteButton from "../buttons/DeleteButton.vue";
import EditButton from "../buttons/EditButton.vue";
import TableView from "../table/TableView.vue";
import donorService from "../../assets/services/donor.service";
import masterService from "../../assets/services/master.service";
import Termination from "./Termination.vue";
import Menu from "./Menu.vue";
import menuConstants from "../../assets/constants/menu.constants";
import ViewButton from "../buttons/ViewButton.vue";
import InputField from "../form/InputField.vue";
import YesNo from "../form/YesNo.vue";
import MLCNotificationLog from "./mlc/MLCNotificationLog.vue";
export default {
  components: {
    TableView,
    EditButton,
    DeleteButton,
    Termination,
    Menu,
    ViewButton,
    InputField,
    YesNo,
    MLCNotificationLog,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    list: Array,
  },
  data() {
    return {
      isDraftLoading: false,
      collapse: false,
      mlcDialog: false,
      mlcSending: false,
      mlcForm: {
        donor_registration_id: "",
        donor_name: "",
        mlc_ar_no: "",
        hospital_name: "",
        mlc_police_mail: "",
        mlc_police_phone: "",
        mlc_nodal_officer_mail: "",
        mlc_nodal_officer_phone: "",
        mlc_hod_forensic_mail: "",
        mlc_hod_forensic_phone: "",
        sendEmail: 1,
        sendSMS: 1,
        sendWhatsApp: 0,
      },
      emailTemplate: null,
      smsTemplate: null,
      whatsappTemplate: null,
    };
  },
  computed: {
    fields() {
      let doc = {
        sno: "S.No",
        donor_temp_registration_id: "Donor ID",
        donor_name: "Donor Name",
        group_desc: "Blood Group",
        hospital_name: "Hospital Name",
        organ_consented: "Organ Consented",
        // phone_number_1: "Phone Number",
        requesting_apnea_moredetails: "Request Note",
        status: "Status",
        action: "Action",
      };
      let list = [];
      Object.keys(doc).forEach((key) => {
        list.push({
          key,
          label: doc[key],
          tdClass: key == "action" ? "width-100" : "",
        });
      });
      return list;
    },
    mlcPlaceholders() {
      return {
        "{contact_type}": "Police / Nodal Officer / HOD Forensic",
        "{hospital_name}": this.mlcForm.hospital_name || "",
        "{ar_no}": this.mlcForm.mlc_ar_no || "",
        "{donor_name}": this.mlcForm.donor_name || "",
        "{date}": new Date().toLocaleString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }),
      };
    },
    filledEmailSubject() {
      if (!this.emailTemplate) return "";
      return this.fillPlaceholders(this.emailTemplate.subject || "");
    },
    filledEmailBody() {
      if (!this.emailTemplate) return "";
      return this.fillPlaceholders(this.emailTemplate.body || "");
    },
    filledSmsBody() {
      if (!this.smsTemplate) return "";
      return this.fillPlaceholders(this.smsTemplate.body || "");
    },
    filledWhatsappBody() {
      if (!this.whatsappTemplate) return "";
      return this.fillPlaceholders(this.whatsappTemplate.body || "");
    },
  },
  watch: {
    collapse(val) {
      if (val) {
        this.$refs.table.resetScroll();
      }
    },
  },
  methods: {
    isView({ status }) {
      let hasAccess = this.hasEditAccess(menuConstants.MANAGE_DONOR);
      return !hasAccess || status == 2 || status == 9;
    },
    isMenu({ status }) {
      return this.isAdmins && (status == 1 || status == 5);
    },
    isDeleteAble({ status }) {
      let statusList = [2, 9, 7, 6];
      if (status == 1) {
        return this.hasStatusAccess(menuConstants.MANAGE_DONOR, 9);
      }
      let hasAccess = this.hasStatusAccess(menuConstants.MANAGE_DONOR, 2);
      return hasAccess && statusList.indexOf(status) == -1;
    },
    isTerminated(item) {
      let statusList = [6, 8];
      let hasAccess = this.hasStatusAccess(menuConstants.MANAGE_DONOR, 7);
      return (
        hasAccess && this.isDeleteAble(item) && statusList.indexOf(status) == -1
      );
    },
    open({ donor_temp_registration_id }) {
      let id = encode(donor_temp_registration_id);
      this.$router.push(`/update-donor?id=${id}`);
    },
    getStatus({ status }) {
      let item = DONOR_STATUS.find((item) => {
        return item.value == status;
      });
      return item != null ? item.name : "";
    },
    remove({ donor_temp_registration_id, status }) {
      const vm = this;
      vm.$confirm.show({
        message: "Are you sure, Do want to remove this donor?",
        onConfirm: () => {
          vm.changeStatus({
            donor_temp_registration_id,
            status: status == 1 ? 9 : 2,
            dml_indicator: "A",
          });
        },
      });
    },
    async changeStatus(doc) {
      const vm = this;
      try {
        vm.$loader.show();
        let { data } = await donorService.updateStatus(doc);
        let { status, msg } = data;
        if (!status) {
          vm.$loader.hide();
          vm.$alert.show(msg);
          return;
        }
        vm.$emit("fetch");
        vm.$loader.hide();
      } catch (error) {
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    },
    fillPlaceholders(text) {
      let result = text;
      const ph = this.mlcPlaceholders;
      Object.keys(ph).forEach((key) => {
        result = result.split(key).join(ph[key]);
      });
      return result;
    },
    async loadTemplates() {
      try {
        let { data } = await masterService.getMessageTemplates("MLC_DONOR_ALERT");
        if (data.status && data.list) {
          this.emailTemplate = data.list.find((t) => t.channel === "EMAIL") || null;
          this.smsTemplate = data.list.find((t) => t.channel === "SMS") || null;
          this.whatsappTemplate = data.list.find((t) => t.channel === "WHATSAPP") || null;
        }
      } catch (e) {
        this.emailTemplate = null;
        this.smsTemplate = null;
        this.whatsappTemplate = null;
      }
    },
    openMLCModal(item) {
      this.mlcForm = {
        donor_registration_id: item.donor_temp_registration_id,
        donor_name: item.donor_name || "",
        mlc_ar_no: item.MLC_AR_No || "",
        hospital_name: item.hospital_name || "",
        mlc_police_mail: item.mlc_police_mail || "",
        mlc_police_phone: item.mlc_police_phone || "",
        mlc_nodal_officer_mail: item.mlc_nodal_officer_mail || "",
        mlc_nodal_officer_phone: item.mlc_nodal_officer_phone || "",
        mlc_hod_forensic_mail: item.mlc_hod_forensic_mail || "",
        mlc_hod_forensic_phone: item.mlc_hod_forensic_phone || "",
        sendEmail: 1,
        sendSMS: 1,
        sendWhatsApp: 0,
      };
      this.loadTemplates();
      this.mlcDialog = true;
    },
    async sendMLCNotification() {
      const vm = this;
      vm.mlcSending = true;
      try {
        vm.$loader.show();
        let { data } = await donorService.sendMLCNotification({
          donor_registration_id: vm.mlcForm.donor_registration_id,
          mlc_police_mail: vm.mlcForm.mlc_police_mail,
          mlc_police_phone: vm.mlcForm.mlc_police_phone,
          mlc_nodal_officer_mail: vm.mlcForm.mlc_nodal_officer_mail,
          mlc_nodal_officer_phone: vm.mlcForm.mlc_nodal_officer_phone,
          mlc_hod_forensic_mail: vm.mlcForm.mlc_hod_forensic_mail,
          mlc_hod_forensic_phone: vm.mlcForm.mlc_hod_forensic_phone,
          send_email: vm.mlcForm.sendEmail == 1,
          send_sms: vm.mlcForm.sendSMS == 1,
          send_whatsapp: vm.mlcForm.sendWhatsApp == 1,
          dml_indicator: "C",
        });
        if (data.status) {
          vm.$alert.show(data.msg, "success");
          if (vm.$refs.mlcLog) {
            vm.$refs.mlcLog.fetchNotifications();
          }
          vm.$emit("fetch");
        } else {
          vm.$alert.show(data.msg || "Failed to send notifications");
        }
      } catch (error) {
        vm.$alert.show("Error sending MLC notification");
      } finally {
        vm.mlcSending = false;
        vm.$loader.hide();
      }
    },
  },
};
</script>

<style></style>
